import isequal from 'lodash/isEqual'

export default (obj1, obj2) => {
  return Object.keys(obj1).reduce((result, key) => {
    if (!obj2[key]) {
      result.push(key)
    } else if (isequal(obj1[key], obj2[key])) {
      const resultKeyIndex = result.indexOf(key)
      result.splice(resultKeyIndex, 1)
    }
    return result
  }, Object.keys(obj2))
}



// WEBPACK FOOTER //
// ./common/utils/objectDiff.js